import { useState } from 'react';
import { Dialog } from '@m/alchemy-ui/Dialog';
import { useSelector } from 'react-redux';
import { RootState } from 'common/store/types';
import {
  SettingsDashboardItem,
  SettingsDashboardItemProps
} from '../SettingsDashboardItem';
import { useFeatureFlag } from 'common/hooks/useFeatureFlags';

function UnfinishedExportsDialog({ isOpen, onDismiss }): JSX.Element | null {
  if (!isOpen) return null;

  return (
    <Dialog
      isOpen
      onClose={onDismiss}
      headerContent="You already have an export in progress"
      bodyContent="In order to keep exports quick, each user is only allowed to have one export generating at a time. You will receive an email when your current export is complete and then you can create another one if needed."
      footerButtons={[{ label: 'OK', onClick: onDismiss }]}
    />
  );
}

export function ExportDashboardItem({
  id,
  link,
  title,
  subtitle,
}: SettingsDashboardItemProps): JSX.Element {
  const [isOpen, setOpen] = useState<boolean>(false);
  const hasUnfinishedExports = useSelector<RootState, boolean>(
    state => state.currentPerson.hasUnfinishedExports
  );

  const isAdvancedExportsEnabled = useFeatureFlag('advanced_exports');

  const openModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const pageLink = isAdvancedExportsEnabled
    ? '/admin/company/feedback_exports'
    : link;

  return (
    <>
      <SettingsDashboardItem
        id={id}
        link={hasUnfinishedExports ? undefined : pageLink}
        title={isAdvancedExportsEnabled ? 'Feedback Exports' : title}
        subtitle={subtitle}
        onClick={hasUnfinishedExports ? openModal : undefined}
      />
      <UnfinishedExportsDialog isOpen={isOpen} onDismiss={closeModal} />
    </>
  );
}
